import { LoginInputType } from './types';
export var clearPhoneNumber = function (phone) {
    if (!phone) {
        return null;
    }
    return phone.replace(/[+()\- ]/g, '');
};
export var detectInputType = function (value) {
    if (/[^0-9+\s]/.test(value)) {
        return LoginInputType.Email;
    }
    else if (value.length > 8) {
        return LoginInputType.Phone;
    }
    else {
        return LoginInputType.Text;
    }
};
